import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

// Shared layout + typography for the full-page legal documents.
export default function LegalLayout({ title, updated, children, testid }) {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div data-testid={testid} className="relative min-h-screen">
      <Nav />
      <main className="pt-28 lg:pt-36 pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-amber-400 transition-colors"
          >
            <ArrowLeft size={16} /> Back to home
          </Link>

          <header className="mt-8 border-b border-white/10 pb-8">
            <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white">
              {title}
            </h1>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-amber-400/80">
              Last updated: {updated}
            </p>
          </header>

          <article className="legal-body mt-10 text-slate-300">
            {children}
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
}

// Reusable primitives for consistent legal typography.
export const H2 = ({ children, id }) => (
  <h2
    id={id}
    className="font-display text-2xl font-bold text-white mt-12 mb-4 scroll-mt-28"
  >
    {children}
  </h2>
);

export const H3 = ({ children }) => (
  <h3 className="font-display text-lg font-semibold text-white mt-7 mb-3">
    {children}
  </h3>
);

export const P = ({ children }) => (
  <p className="text-[15px] leading-relaxed text-slate-300 mb-4">{children}</p>
);

export const UL = ({ children }) => (
  <ul className="mb-5 space-y-2 pl-5">{children}</ul>
);

export const LI = ({ children }) => (
  <li className="list-disc text-[15px] leading-relaxed text-slate-300 marker:text-amber-400/70">
    {children}
  </li>
);

// Callout box for the verbatim compliance passages.
export const Verbatim = ({ children, testid }) => (
  <blockquote
    data-testid={testid}
    className="my-6 rounded-xl border-l-2 border-amber-400 bg-[#121927] p-5 text-[15px] leading-relaxed text-slate-200"
  >
    {children}
  </blockquote>
);
